/**
 * Comment un chiffre mesuré se lit (V1.6-11).
 *
 * Séparé du composant pour que la mise en forme se teste seule, et parce
 * qu'un module qui exporte à la fois des composants et des fonctions casse le
 * rechargement à chaud.
 */
import type { Metric } from "@/api/types";

/** Comment lire la valeur brute rendue par le serveur. */
export type MetricKind = "rate" | "hours" | "days" | "count";

export const NOT_MEASURABLE = "Non mesurable : HD-Vault n'enregistre pas ce qu'il faudrait pour ce calcul.";
export const NOT_ENOUGH = "Pas assez de données sur cette période.";

export function formatMetric(metric: Metric, kind: MetricKind): string {
  if (metric.status !== "AVAILABLE" || metric.value === null) return "—";
  const value = Number(metric.value);
  switch (kind) {
    case "rate":
      return `${Math.round(value * 1000) / 10} %`;
    case "hours":
      // Au-delà de deux jours, une durée en heures ne se lit plus.
      return value >= 48 ? `${Math.round(value / 24)} j` : `${Math.round(value)} h`;
    case "days":
      return `${Math.round(value * 10) / 10} j`;
    default:
      return String(value);
  }
}

